import { useMutation } from "@tanstack/react-query";
import { updateLeatFieldMappings } from "../../api/bLeatApi";

export const useUpdateLeatFieldMappings = () => {
  return useMutation({
    mutationKey: ["update-leat-field-mappings"],
    mutationFn: (data) => updateLeatFieldMappings(data),
    onError: (error) => {
      console.error("Leat field mappings error:", error.response || error);
    },
  });
};
